import React from 'react'

export default class PVHeader extends React.Component{
	render() {
		const {
			pvEndData,
			lang,
			newheadline
		} = this.props

		const headerData = pvEndData.screen_1
		let headline = headerData.text_1
		if(newheadline){
			headline = newheadline
		}
		let icon = headerData.icon_black
		if(icon){
			icon = headerData.icon_black.filename
		}
		const iconpath = lang.concat('/PV_End/screen_1/', icon)

		return(
			<div className = 'pvHeader'>
				<div className ='headline'>{headline}</div>
				<div className ='icon' style={{'backgroundImage': `url(${iconpath})`}}/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/presentationReferral/subcomponents/pvHeader.js